var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "IconHelpButtonQuestionMark",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibs-vg-svg svg-icon-help-button-question-mark","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M180.028 18.827C193.346 31.51 200 47.54 200 66.93c0 11.93-2.396 21.624-7.2 28.892-4.814 7.268-14.622 18.086-29.6 32.442-10.912 10.436-17.944 19.198-21.276 26.478-3.333 7.077-4.993 16.95-4.993 31.88h-29.59c0-16.794 2.028-28.904 5.728-38.598 3.7-9.695 12.215-20.872 25.154-33.554l13.508-13.233c4.068-3.92 7.4-7.83 9.986-11.941 4.614-7.268 6.843-14.727 6.843-22.546 0-11.009-3.321-20.523-9.986-28.533-6.475-8.2-17.386-12.12-32.733-12.12-18.88 0-31.997 7.088-39.219 20.882-4.068 7.65-6.475 18.457-7.032 33.375H50c0-24.242 6.843-43.81 20.529-58.358C84.215 7.448 103.083 0 126.945 0c22.2 0 39.765 6.336 53.083 18.827zM107.331 250v-35.43h33.29V250h-33.29z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/icon-help-button-question-mark.svg